const accordionData = {
    
        accordionData1: [

            {
                question: "The beneficiary's preferred name field has been added to more screens",
                answer:
                    "We've added a 'preferred name' field to more beneficiary screens, so you'll now see it in the following:</p><p><ul><li>Pending approvals.</li><li>create and/or edit a single debit multi credit payment.</li><li>create and/or edit a single debit, single credit payment.</li><li>create and/or edit a template. </li><li>add another beneficiary.</li><li>search for a beneficiary (for both domestic and international payments).</li></ul>"
            },
            {
                question: "Future dated manual FX payments rejections",
                answer:
                    "We've added an option to 'reject' a payment when in the 'Action' menu of the pending approvals screen.  This means you'll be able to reject and therefore remove a manual FX future dated payment from the pending approvals list if it has an execution date of today or in the past."
            },
            {
                question: "Improved transaction search options",
                answer:
                    "We’ve made it easier for you to drill down into transaction details by adding ‘Advanced search’ functionality to the Transaction history screen. This will allow you to search transactions by type, amount, by posting date or within a range of amounts."
            },
            {
                question: "Payment approval columns have been enhanced",
                answer:
                    "To make payment approvals easier, we’ve added ‘account name’ as an optional column within the approvals screen.  You’ll be able to add this column to your view via manage columns, from the 3-dot action menu on the right-hand side."
            },
            {
                question: "Searching for Accounts by Virtual Structure just got easier",
                answer:
                    "We’ve added IBAN as a new optional column, this column will also be available when exporting. You’ll no longer need to access the tree view and select each account individually to be able to see this detail."
            },

        ],


        accordionData2: [
            {
                question: "Extended child entity administration entitlements",
                answer:
                    "We’ve changed entitlements for Primary Administrator users created after onboarding, so any new Primary Admin users will be assigned as an Administrator in <strong>all</strong> entities within the structure.<br/><br/>You’ll be able to see this via the Admin>Company>Administrators navigation, you’ll also be able to remove these entitlements via the ‘Edit’ function, if required."
            },
            {
                question: "Screen navigation improvements",
                answer:
                    "We’ve moved some action buttons to the left side of some screens and fixed them in position, so they’re always visible to you.  This means you’ll be able to scroll right and still be able to access the three-dot action menu on the Payment Summary and Accounts by Entity screens; the ‘Details’ button on the Transaction history screen and the ‘View’ button on the Approvals, Pending Approvals and Transactions screens."
            },
            {
                question: "Screen reader tool fixes",
                answer:
                    "We’ve fixed some issues with our screen reader tool relating to some read only content, which will help improve navigation around Gem Connect."
            },
            {
                question: "Countdown to being logged out",
                answer:
                    "You’ll now see a warning pop up when a session has been idle and is about to log a user out."
            }
        ],
        accordionData3: [
            {
                question: "Enhanced reporting when exporting in CSV format",
                answer:
                    "We've enhanced reporting functionality when exporting the 'Transaction detail’ report and/or the ‘Balance and Transaction Detail' report in either .CSV or .CSV consolidated format.  This means you'll now be able to select a larger number of accounts with a date range of up to 12 months.  You can find out more about this in our Information reporting page on Help and Support."
            },
            {
                question: "We’ve added the Beneficiary’s preferred name field to beneficiary import",
                answer: "You’ll be able to include a beneficiary’s preferred name when importing both domestic and international beneficiaries.  We’ve also added it to the Payments > Summary > Pending payments screen."
                               
            },
            {
                question: "Searching for transactions has been enhanced",
                answer: "We’ve made changes to the Advanced search functionality on the Approvals > Pending approvals > Transactions screen so you’ll have more fields available.  You’ll now be able to search transactions by Beneficiary name, Debit account reference, Template name, and Preferred name (for a beneficiary)."
                               
            },
            {
                question: "Search selection table improvements",
                answer: "We’ve made changes to the search section of some screens giving you more space to see transactions. You’ll now be able to minimise the search element on the following screens:<p></p><ul><li>Payment summary (Approved, Recurring and Pending)</li><li>Transaction history</li><li>Accounts by virtual structure</li></ul>"
                               
            },
            {
                question: "A larger ‘View’ pop up window for Payments (pending & approval)",
                answer: "The Payments summary ‘View’ pop up window, for Pending payments and Pending approvals> Transactions has been updated to make it wider and longer, so easier to read."
                               
            }
        ],
        accordionData4: [
            {
                question: "You can now change your password online",
                answer: "We’ve listened to your feedback, and we’ve updated our system functionality, so you can change your password online.  You’ll now be able to click on the ‘Forgotten password’ link, and you’ll be prompted for additional security details, before being asked to create a new password."
            },
            {
                question: "We’re adding some new fields to our payment screens",
                answer: "You’ll now see new ‘Payment purpose code’ (PPC) and will soon see ‘LEI’ (Legal Entity Identifier) fields on our payment screens.  Payment purpose codes are a four-character alphanumeric code which can be added to a payment instruction then carried across the payment chain, providing information to all users. A full list of codes can be found within our ‘Reference documentation’ section, within Help and Support.  A Legal Entity Identifier (LEI) is a 20-character alphanumeric code. It is a global standard designed to uniquely identify any legally distinct entity which engages in financial transactions.  These fields will become mandatory in 2025."
                               
            },
            {
                question: "We’ve updated our .XML and .CSV transaction upload templates",
                answer: "We’ve updated our templates to accommodate the new ‘Payment purpose code’ (PPC) and ‘LEI’ (Legal Entity Identifier) fields."
                               
            },
            {
                question: "Two new audit report options",
                answer: "We’ve added two new audit reports ‘User status’ and ‘User activity’ which you can find below the existing 'Manage users' and 'Create users' reports."
                               
            }
        ],
        accordionData5: [
            {
                question: "Enhanced Payment approval workflow functionality",
                answer: "Existing Payment approval workflows are unchanged&nbsp;&nbsp;&nbsp;However, we’re delighted to let you know we’ve added functionality to enable clients with multiple entities, to be able to set up different payment approval workflows, specific to particular entities within their group.&nbsp;&nbsp;&nbsp;New payment approval workflows can only be set up by parent entity administrators and they <strong>must be approved</strong> before they can take effect.&nbsp;&nbsp;&nbsp;You can find out more about this in our Payment approval workflow page on Help and Support."
            },
            {
                question: "We’ve added our Lloyds Bank logo to our Transaction history exports",
                answer: "You’ll now see our logo on the top right of our Transaction history reports when they’re exported in either .pdf or .HTML format."
                               
            },
            {
                question: "Additional print functionality",
                answer: "You’ve previously told us you want more print functionality for our payment screens, so we’ve added a print button to our Pending payments&nbsp;&gt;&nbsp;view screen.  You’ll now see a new ‘Print’ button on the bottom right of the page, next to the existing ‘Cancel’, ‘Delete’ and ‘Edit’ buttons."
                               
            },
            {
                question: "Enhanced System Activity Report",
                answer: "The System Activity Report (SAR) is an audit report which records user activity in Gem Connect. This will now include 'Entity' and 'Activity type' details for all add, edit, and delete payment workflow approvals. The ‘Description’ column will include the specific actions taken, amount ranges, and the users or groups involved. Only new levels added to an existing approval chain will be shown, and for edits, only the final state details will be reported."
                               
            },
            {
                question: "We’ve further improved advanced search options",
                answer: "We’ve made changes to the Advanced search functionality on the Payment summary&nbsp;&gt;&nbsp;Pending payments screen. You’ll now be able to search transactions by Beneficiary name and Debit account reference."
                               
            }
        ]
    }



export default accordionData;


// WEBPACK FOOTER //
// ./src/components/newHelpSupportItems/accordionData.ts